import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { InAppBrowser } from '@app/core/services/in-app-browser/in-app-browser.service';
import { Http, HttpOptions } from '@capacitor-community/http';
import { StorageService } from '@core/services/storage/storage.service';
import { environment } from '@env';
import { TranslateService } from '@ngx-translate/core';
import { CloudFolder } from '@shared/models/file-types';
import { BOX_REDIRECT_URL, SOCIAL_URL } from '../constants/app-constant';
import { STORAGE_CONST } from '../constants/storage-constants';
import { LoadingService } from '../services/loading/loading.service';
import { ToastService } from '../services/toast/toast.service';

@Injectable()
export class Box {
  accessToken: any;
  folderHistory: CloudFolder[] = [
    {
      name: 'Home',
      id: '0',
    },
  ];
  clientID = environment.boxClientID;
  clientSecret = environment.boxClientSecret;
  // clientID = 'pcv9pwr2a3mqm03ho0ofhhczjfhzablu';
  // clientSecret = 'hFjRO02Hq1eOaWLZLGmWkAkSWc5x3HKI';
  // developerToken = 'JAfcZpXhu6HMD8OgWHWiFZ99T4MJCmiX';
  developerToken = null;
  // redirectURI = environment.redirectBaseUrl + 'box';
  // url: any;
  box: any;
  isLoginRunning = false;

  // endpoint = "http://localhost:3000/users";

  constructor(
    private httpClient: HttpClient,
    private loadingSvc: LoadingService,
    private storageSvc: StorageService,
    private translateService: TranslateService,
    private router: Router,
    private toastService: ToastService,
    private iab: InAppBrowser
  ) {
    // this.url = SOCIAL_URL.boxAuthorize;
    // this.url =
    //   "https://account.box.com/api/oauth2/authorize?client_id=" +
    //   this.clientID +
    //   "&redirect_uri=" +
    //   this.redirectURI +
    //   "&response_type=code";
  }

  setAccessToken(token) {
    this.accessToken = token;
  }

  getRootFolder() { }

  getFolders(
    folderId = '0',
    name: string = this.translateService.instant('ALL_FILES')
  ): Promise<any> {
    const history = this.folderHistory;

    const i = history.findIndex((e) => e.id === folderId);

    if (i >= 0) {
      this.folderHistory = history.slice(0, i);
    }

    this.folderHistory.push({
      id: folderId,
      name,
    });

    // if (!this.folderHistory.includes(folderId)) {
    //   this.folderHistory.push(folderId);
    // }
    const httpOptions: HttpOptions = {
      // url: "https://api.box.com/2.0/folders/" + folderId + "/items",
      url: SOCIAL_URL.boxFolder(folderId),
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.accessToken,
      },
      params: {},
    };

    // let folderPath;

    // if (typeof folderId == 'undefined' || !folderId) {
    //   folderPath = {
    //     path: '',
    //   };
    // } else {
    //   folderPath = {
    //     path,
    //   };

    // }

    return Http.get(httpOptions);
  }

  downloadFile(fileID) {
    //https://api.box.com/2.0/files/:file_id/content
    // const httpOptions: HttpOptions = {
    //   url: `https://api.box.com/2.0/files/${fileID}/content`,
    //   headers: {
    //     'Content-Type': 'application/json',
    //     Authorization: 'Bearer ' + this.accessToken,
    //   },
    // };

    // return Http.get(httpOptions)
    //   .then((response) => response.data)
    //   .then((stream) => new Response(stream))
    //   .then((response) => response.blob());

    return new Promise<any>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      // xhr.open("GET", `https://api.box.com/2.0/files/${fileID}/content`, true);
      xhr.open('GET', SOCIAL_URL.boxFile(fileID), true);
      xhr.setRequestHeader('Authorization', 'Bearer ' + this.accessToken);
      // xhr.setRequestHeader( 'Dropbox-API-Arg', JSON.stringify({ path:  filePath }));
      xhr.responseType = 'arraybuffer';
      xhr.onload = async () => {
        resolve(xhr.response);
      };
      xhr.send();
    });
  }

  authorize() {
    return new Promise(async (resolve, reject) => {
      const browser = this.iab.create(
        SOCIAL_URL.boxAuthorize,
        '_system',
        {}
      );

      const listener = browser.on('loadstart').subscribe(async (res) => {
        //Ignore the dropbox authorize screen
        if (res.url.indexOf('oauth2/authorize') > -1) {
          return;
        }
        //Check the redirect uri
        if (res.url.indexOf(BOX_REDIRECT_URL) > -1) {
          const token = res.url.split('=')[1].split('&')[0];

          listener.unsubscribe();
          browser.close();
          await this.loadingSvc.present();
          await this.fetchToken(token);
          await this.loadingSvc.dismiss();
          resolve(true);
        } else {
          reject(this.translateService.instant('COULD_NOT_AUTHENTICATE'));
        }
      });
    });
  }

  saveToken(token) {
    const cstamp = this.currentTimestamp();
    token.expires = Number(token.expires_in ? token.expires_in : '0') + cstamp;
    this.storageSvc.setJson(STORAGE_CONST.BOX_TOKEN, token);
  }

  fetchToken(code): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
        }),
      };

      const body = {
        code,
        grant_type: 'authorization_code',
        client_id: this.clientID,
        client_secret: this.clientSecret,
      };

      this.httpClient
        .post(
          // "https://api.box.com/oauth2/token",
          SOCIAL_URL.boxToken,
          new HttpParams({
            fromObject: body,
          }),
          httpOptions
        )
        .subscribe({
          next: (res: any) => {
            this.saveToken(res);
            resolve(true);
          },
          error: (error) => {
            console.error(error);
            reject(error);
          },
        });
    });
  }
  refreshToken(token): Promise<string> {
    return new Promise(async (resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
        }),
      };

      const body = {
        refresh_token: token,
        grant_type: 'refresh_token',
        client_id: this.clientID,
        client_secret: this.clientSecret,
      };

      this.httpClient
        .post(
          // 'https://api.box.com/oauth2/token',
          SOCIAL_URL.boxToken,
          new HttpParams({
            fromObject: body,
          }),
          httpOptions
        )
        .subscribe({
          next: (res: any) => {
            this.saveToken(res);
            resolve(res.access_token);
          },
          error: (error) => {
            console.error(error);
            resolve(null);
          },
        });
    });
  }

  async getToken() {
    const cstamp = this.currentTimestamp();
    const obj = await this.storageSvc.getJson(STORAGE_CONST.BOX_TOKEN);
    if (obj) {
      if (obj.expires > cstamp) {
        return obj.access_token;
      } else {
        const token = await this.refreshToken(obj.refresh_token);
        return token;
      }
    }

    return null;
  }
  boxBrowserLoginHandler(url: string) {
    if (this.isLoginRunning) {
      return null;
    }
    this.isLoginRunning = true;
    // const token = url.split('?code=')[1];
    const urlParams = new URLSearchParams(url.split('?')[1]);
    const token = urlParams.get('code');
    if (token && token.length > 0) {
      this.fetchToken(token)
        .then((success) => {
          if (success) {
            this.router.navigate(['/app/add-files/box-list']);
          }
        })
        .catch(async () => {
          this.toastService.showErrorToast();
        })
        .finally(() => {
          this.isLoginRunning = false;
        });
      return this.router.navigate(['/app/add-files']);
    }
    return null;
  }

  private currentTimestamp(): number {
    return Math.floor(new Date().getTime() / 1000);
  }
}
